let AbstractImporter = require('../../io/import/abstractImporter');

/**
 * Класс GeoJsonImporter
 * @extends AbstractImporter
 */
class GeoJsonImporter extends AbstractImporter{
  constructor(params){
    super(params);
  }
}

module.exports = GeoJsonImporter;